<template>
  <div class="detail-container" :loaded="loaded">
    <common-bg-image
      content="成绩复核报告"
      :informationObj="informationObj"
      :scoreObj="scoreObj"
      :showPDFStyle="true"
      :cancelHeight="false"
    ></common-bg-image>
    <div :class="{ noscroll: !showAllInformation }" class="box">
      <common-information-card
        class="cards"
        :name="name"
        :showAllInformation="showAllInformation"
        :informationList="informationList"
      ></common-information-card>
      <div v-if="!showAllInformation" class="detail-nobuy">
        <answer-detail-line
          title="明细分"
          style="opacity: 0.8"
        ></answer-detail-line>
        <div class="tr">
          <span>试题序号</span>
          <span>实得分/应得分</span>
          <span>答题次数</span>
          <span>答题用时</span>
        </div>
        <div class="cover"></div>
        <div class="tip">
          <span class="desc">{{ descContent }}</span>
          <div
            @click="buyReportClick"
            :class="{ disabled: disabled }"
            class="buy-report"
          >
            购买报告
          </div>
        </div>
      </div>
      <question-detail
        :tableDetail="tableDetail"
        :quesTypeDetail="quesTypeDetail"
        v-if="showAllInformation"
      ></question-detail>
      <common-report-explain
        class="explain"
        :reportExplainObjCopy="reportExplainObjCopy"
        v-if="showAllInformation"
      >
      </common-report-explain>
    </div>
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { replaceTime, getDate } from "../../js/current";
import {
  scoreDetailVisited,
  getScoreDetailReport,
  getProductList,
} from "../../api/index";
import CommonBgImage from "../../components/commonBgImage.vue";
import CommonInformationCard from "../../components/commonInformationCard.vue";
import AnswerDetailLine from "./components/answerDetailLine";
import QuestionDetail from "./components/questionDetail";
import CommonReportExplain from "../../components/commonReportExplain.vue";
export default {
  name: "downloadPDF",
  components: {
    CommonBgImage,
    CommonInformationCard,
    AnswerDetailLine,
    QuestionDetail,
    CommonReportExplain,
  },
  setup() {
    // 定义store
    const store = useStore();
    // 写死一个列表数据
    const informationList = ref([
      {
        key: "性别",
      },
      {
        key: "证件号",
      },
      {
        key: "准考证号",
      },
      {
        key: "考场",
      },
      {
        key: "考试机号",
        addClass: true,
      },
      {
        key: "开考时间",
      },
      {
        key: "结束时间",
      },
      {
        key: "答题时间",
      },
    ]);
    // 定义router
    const router = useRouter();
    // 定义route query中取到的参数
    let batchCode = ref("");
    let perm = ref("");
    /** 根据状态对提示文字内容和按钮样式的控制 */
    // 为购买报告增加一个动态class disabled
    let disabled = ref(false);
    // 定义描述文字在不同购买状态下不同
    let descContent = ref("");
    // 获取此考生明细报告的获取状态 未买/买未付款/已买已发货/已买未发货
    const getScoreDetailStatus = async () => {
      try {
        const { data } = await scoreDetailVisited(
          batchCode.value,
          perm.value,
          route.query.ProdBatchId,
          route.query.ProjectCode,
          true
        );
        if (data === -1 || data === -2 || data === -99) {
          descContent.value = "查看明细分，了解成绩详情";
        } else if (data === 0 || data === -10) {
          descContent.value = "您已购买报告，待发放";
          disabled.value = true;
        } else if (data === 1) {
          // 调用查看明细
          showAllInformation.value = true;
        }
        return data; // 返回数据
      } catch (error) {
        console.log(error);
        throw error; // 抛出错误
      }
    };

    /** 获取数据信息和明细信息 */
    // 定义card的name
    const name = ref("");
    // 定义合格状态去判断背景颜色和显示文字
    const bgImageStatus = ref("");
    // 满分和总题数信息
    const scoreObj = ref({});
    // 定义背景上的信息
    const informationObj = ref({});
    // 是否展示全部基本信息
    const showAllInformation = ref(false);
    // 明细分数据
    let tableDetail = ref([]);
    // 题型分明细数据
    let quesTypeDetail = ref([]);
    // 获取答题明细
    const getScoreDetail = async () => {
      try {
        const data = await getScoreDetailReport(
          batchCode.value,
          perm.value,
          route.query.ProdBatchId,
          route.query.ProjectCode,
          true
        );
        const { code } = data;
        if (code === 0) {
          const { scoreExamInfo, itemDetail, sectionInfo } = data.data;
          const {
            credentialsID,
            perm,
            sex,
            status,
            candidateName,
            grade,
            examTime,
            subjectName,
            total,
            quesCount,
            examCenter,
            examRoom,
            seatNumber,
            startTime,
            endTime,
            timeUsed,
          } = scoreExamInfo;
          tableDetail.value = itemDetail;
          quesTypeDetail.value = sectionInfo;
          informationList.value[0].value = sex;
          informationList.value[1].value = credentialsID;
          informationList.value[2].value = perm;
          informationList.value[3].value = `${examCenter}${examRoom}`;
          informationList.value[4].value = seatNumber;
          informationList.value[5].value = replaceTime(startTime);
          informationList.value[6].value = replaceTime(endTime);
          informationList.value[7].value = `${timeUsed} s`;
          name.value = candidateName;
          if (status === -2) {
            bgImageStatus.value = "invalid";
          } else if (status === -1) {
            bgImageStatus.value = "no";
          } else if (status === 0) {
            bgImageStatus.value = "unsuccess";
          } else {
            bgImageStatus.value = "success";
          }
          scoreObj.value.totalScore = total;
          scoreObj.value.questionCount = quesCount;
          informationObj.value = {
            grade,
            subjectName,
            bgImageStatus: bgImageStatus,
            examTime: getDate(examTime),
          };
        }
        return data; // 返回数据
      } catch (error) {
        console.log(error);
        throw error; // 抛出错误
      }
    };
    // 购买报告
    const buyReportClick = () => {
      // showAllInformation.value = true
      // router.push('paymentResult')
      router.push("/orderDetails");
    };
    // 定义route对象
    const route = useRoute();

    // 获取商品列表
    const reportExplainObjCopy = ref("");
    const getProdList = async (batchCode) => {
      try {
        const { data } = await getProductList(
          batchCode,
          route.query.ProjectCode,
          true
        );
        reportExplainObjCopy.value = data[0].desc;
        return data; // 返回数据
      } catch (error) {
        console.log(error);
        throw error; // 抛出错误
      }
    };
    const loaded = ref(false);
    onMounted(() => {
      const { BatchCode, Perm } = route.query;
      batchCode.value = BatchCode;
      perm.value = Perm;
      Promise.all([
        getScoreDetailStatus(),
        getScoreDetail(),
        getProdList(BatchCode),
      ]).then((res) => {
        setTimeout(() => {
          loaded.value = true;
        }, 200);
      });
    });
    return {
      buyReportClick,
      informationList,
      showAllInformation,
      informationObj,
      name,
      scoreObj,
      descContent,
      disabled,
      tableDetail,
      quesTypeDetail,
      batchCode,
      reportExplainObjCopy,
      loaded,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "scss/base.scss";
@import "scss/color.scss";
.detail-container {
  overflow: auto;
  padding-bottom: 20px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #f4f4f4;
  display: flex;
  .box {
    margin-top: -60px;
    // height: 58%;
    // flex: 1;
    .cards {
      height: auto !important;
    }
    .detail-nobuy {
      display: flex;
      flex: 1;
      height: 100%;
      flex-direction: column;
      position: relative;
      background-color: #fff;
      width: 702px;
      padding: 30px;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 20px;
      border-radius: 16px 16px 0px 0px;
      box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.05);
      .tr {
        margin-top: 60px;
        width: 100%;
        color: #333;
        display: flex;
        justify-content: space-between;
        font-size: 28px;
      }
      .cover {
        @include flex-center;
        flex-direction: column;
        width: 702px;
        background-color: #fff;
        position: absolute;
        top: 100px;
        left: 0;
        bottom: 0;
        opacity: 0.6;
      }
      .tip {
        @include flex-center;
        flex-direction: column;
        position: absolute;
        top: 50%;
        width: 100%;
        left: 50%;
        transform: translateX(-50%);
        .desc {
          font-size: 28px;
          color: #333;
          width: 100%;
          text-align: center;
        }
        .buy-report {
          @include flex-center;
          width: 248px;
          height: 80px;
          font-size: 28px;
          color: #fff;
          background: var(--primary-color);
          border-radius: 40px;
          margin-top: 30px;
          &.disabled {
            background-color: #ccc;
            cursor: not-allowed;
            pointer-events: none;
          }
        }
      }
    }
    &.noscroll {
      overflow: hidden;
    }
  }
  .download {
    @include flex-center;
    width: 702px;
    height: 86px;
    font-size: 28px;
    color: #fff;
    background: var(--primary-color);
    border-radius: 40px;
    margin-top: 30px;
  }
}
</style>
